<template>
  <v-navigation-drawer
    v-if="shouldShowSearchHistoryDrawer"
    v-model="drawerModel"
    :stateless="true"
    disable-resize-watcher
    right
    app
    clipped
    temporary
    dark
    color="secondary"
    width="400"
    class="search-history-drawer"
  >
    <div
      ref="drawerInner"
      class="search-history-drawer__inner"
      tabindex="-1"
      @mousedown="onDrawerMouseDown"
    >
      <search-history v-if="isOpen" dark @closeDrawer="close" />
    </div>
  </v-navigation-drawer>
</template>

<script>
import SearchHistory from './SearchHistory.vue';

export default {
  name: 'SearchHistoryDrawer',

  components: {
    SearchHistory,
  },

  props: {
    shouldShowSearchHistoryDrawer: {
      type: Boolean,
      default: false,
    },
    rightDrawerOpen: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpen: false,
      outsideClickListening: false,
      onOutsidePointerDown: null,
    };
  },

  computed: {
    drawerModel: {
      get() {
        return this.isOpen;
      },
      set(next) {
        if (!next) {
          this.close();
          return;
        }
        this.open();
      },
    },
  },

  watch: {
    isOpen(val) {
      if (!val) {
        this.removeOutsideClickListener();
        return;
      }
      this.addOutsideClickListener();
    },

    rightDrawerOpen(isOpen) {
      if (isOpen) {
        this.close();
      }
    },
  },

  beforeDestroy() {
    this.removeOutsideClickListener();
  },

  methods: {
    open() {
      this.isOpen = true;
      this.$emit('close-utility-drawers');
    },

    close() {
      this.isOpen = false;
    },

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    },

    onDrawerMouseDown() {
      const el = this.$refs.drawerInner;
      if (el && document.activeElement !== el) {
        el.focus({ preventScroll: true });
      }
    },

    isPointerInDrawer(target) {
      return Boolean(
        target && target.closest && target.closest('.search-history-drawer')
      );
    },

    isPointerInSearchHistoryTrigger(target) {
      return Boolean(
        target && target.closest && target.closest('.search-history-trigger')
      );
    },

    addOutsideClickListener() {
      if (this.outsideClickListening) {
        return;
      }

      this.onOutsidePointerDown = (e) => {
        if (!this.isOpen) {
          return;
        }

        const inDrawer = this.isPointerInDrawer(e.target);
        const inSearchHistoryTrigger = this.isPointerInSearchHistoryTrigger(e.target);
        const inMenu = e.target.closest && e.target.closest('.menuable__content__active');

        if (inDrawer || inSearchHistoryTrigger || inMenu) {
          return;
        }

        this.close();
      };

      document.addEventListener('pointerdown', this.onOutsidePointerDown, true);
      this.outsideClickListening = true;
    },

    removeOutsideClickListener() {
      if (!this.outsideClickListening) {
        return;
      }

      document.removeEventListener('pointerdown', this.onOutsidePointerDown, true);
      this.outsideClickListening = false;
    },
  },
};
</script>

<style>
/*
 * Vuetify 2 only applies clipped top offset when the drawer is not temporary
 * (hasApp is false for temporary drawers). Position below the app header.
 */
.search-history-drawer.v-navigation-drawer--fixed {
  top: var(--app-header-height, 64px) !important;
  height: calc(100% - var(--app-header-height, 64px)) !important;
  max-height: calc(100% - var(--app-header-height, 64px)) !important;
}

.search-history-drawer >>> .v-navigation-drawer__content {
  height: 100%;
  overflow: hidden;
  background: #12253a;
}

.search-history-drawer__inner {
  height: 100%;
  overflow: hidden;
}
</style>
